'use client';

import Link from 'next/link';
import { Info } from 'lucide-react';
import { InfoModal } from '@/components/ui/InfoModal/InfoModal';
import { A2_BLOG_URL, A2_BLOG_TITLE } from '@/utils/links';

interface Props {
  open: boolean;
  onClose: () => void;
}

const MESSAGE = (
  <div className="flex flex-col gap-4 text-zinc-400 text-base">
    <p>
      This pack contains only A1 or custom models. Preview and most features are
      disabled. Scroll to &quot;Models&quot; to download.
    </p>
    <div className="flex flex-col gap-1">
      <p>Why you&apos;re seeing this:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>The creator only provided A1 or custom models</li>
        <li>The models didn&apos;t meet A2 retraining criteria</li>
      </ul>
    </div>
    <p>
      Learn more:{' '}
      <Link
        href={A2_BLOG_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 hover:underline"
      >
        {A2_BLOG_TITLE}
      </Link>
    </p>
  </div>
);

export const NoA2ModelsModal = ({ open, onClose }: Props) => {
  return (
    <InfoModal
      open={open}
      onClose={onClose}
      title="No A2 Models"
      icon={<Info size={24} className="text-white" />}
      message={MESSAGE}
      // Suppress InfoModal's auto-rendered "Close" button — design uses only
      // the header X for dismissal.
      action={<></>}
    />
  );
};
